import axiosSetting from '@/common/axiosSetting'
const state = {
	hasEdit : false
};
const mutations = {
	changeUserReturnStatus (state,n) {
		state.hasEdit = n;
	}
};
const actions = {
	changeUserReturnStatusAsync ({ commit }) {
		axiosSetting.AxiosIns({
			url : 'back_home/query.json'
		}).then((res)=>{
			let status = false;
			let endTime = res.meeting.end_time;
			let startTime = res.meeting.start_time;
			let now = Math.round(new Date().getTime()/1000);
			if(!res.data && startTime < now && endTime > now){
				status = true;
			}
			commit('changeUserReturnStatus',status)
		});
	}
};
export default {
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/storage/vuex/module/userReturnBack.js